import axios from 'axios';
import VodService from './VodService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Playout is a calendar UI + gap-filling on top of the existing VOD/failover
// engine — most of what it needs (schedules, playlists, assets, the
// account-wide auto-failover toggle) already has a working endpoint under
// /api/vod/*, so this service delegates to VodService for those and only
// talks to the new /api/playout/* routes directly for what's actually new.
class PlayoutService {
  static async access() {
    try {
      const { data } = await api.get('/playout/access');
      return !!data.allowed;
    } catch { return false; }
  }

  static async getCalendar(streamId) {
    const { data } = await api.get('/playout/calendar', { params: { stream_id: streamId } });
    return data.schedules || [];
  }

  static async fillGaps(payload) {
    const { data } = await api.post('/playout/fill-gaps', payload);
    return data;
  }

  // ---- delegated to the existing VOD engine, unchanged ----
  static async getStreams() {
    const r = await VodService.getAllStreams();
    return r.data || [];
  }
  static async getAssets() {
    const r = await VodService.getAllAssets();
    return r.assets || [];
  }
  static async getPlaylists() {
    const r = await VodService.getAllPlaylists();
    return r.playlists || [];
  }
  static async createSchedule(payload) {
    return VodService.createSchedule(payload);
  }
  static async updateSchedule(id, updates) {
    return VodService.updateSchedule(id, updates);
  }
  static async deleteSchedule(id) {
    return VodService.deleteSchedule(id);
  }
  static async updatePlaylist(id, updates) {
    return VodService.updatePlaylist(id, updates);
  }
  static async getFailoverSettings() {
    return VodService.getFailoverSettings();
  }
  static async setFailoverSettings(enabled) {
    return VodService.setFailoverSettings(enabled);
  }
}

export default PlayoutService;
